(function () {

    angular
        .module('smartertoolsApp')
        .directive('stPaymentForm', ['payments', '$timeout', stPaymentForm]);

    function stPaymentForm(paymentService, $timeout) {
        return {
            require: '^form',
            scope: {
                methods: '=stMethods',
                selectedMethod: '=stSelectedMethod',
                disableInvoicing: '=stDisableInvoicing',
                shorterDuePolicy: '=?stShorterDuePolicy',
                alwaysSave: '=stAlwaysSave',
                disableCvc: '=stDisableCvc'
            },
            templateUrl: '/app/global/components/st-payment-form.html',
            link: {
                post: function (scope, element, attrs, formCtrl) {
                    scope.form = formCtrl;
                    scope._DirectiveName = 'stPaymentForm';
                    scope.countryList = geographicLocations.countries;
                    scope.stateList = geographicLocations.statesByCountry;
                    scope.shorterDuePolicy = !!scope.shorterDuePolicy;

                    paymentService.getPaymentMethods()
                        .then(function (result) {
                            const result2 = [];
                            for (let i = 0; i < result.length; i++) {
                                let item = result[i];
                                if (scope.disableInvoicing && item.PaymentType === 'invoice')
                                    continue;
                                if (scope.alwaysSave)
                                    item.SaveCard = true;
                                result2.push(item);
                            }
                            scope.methods = result2;
                            scope.invoiceLaterText = paymentService.invoiceLaterText;
                            scope.selectedMethod = scope.methods && scope.methods.length > 0
                                ? scope.methods[0]
                                : null;
                            scope.selectedPaymentMethodId = scope.selectedMethod == null ? null : scope.selectedMethod.UniqueId;
                        });

                    scope.selectedPaymentMethodIdChanged = function () {
                        scope.selectedMethod = null;
                        if (scope.methods == null)
                            return;
                        for (let i = 0; i < scope.methods.length; i++) {
                            const item = scope.methods[i];
                            if (item.UniqueId == scope.selectedPaymentMethodId) {
                                scope.selectedMethod = item;
                                break;
                            }
                        }
                    };
                    $timeout(function () {
                        // this code will execute after the render phase
                        RecalculateAllFloatLabelControls();
                    });
                }
            }
        };
    }
})();